export default __webpack_public_path__ + "media/images/ui-bg_glass_65_ffffff_1x400-f6f0260acfe4bb35b0730697e066cfd8.png";